import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import reducer from './rootReducer';

export default configureStore({
  reducer,
  middleware:
    process.env.NODE_ENV !== 'development'
      ? (getDefaultMiddleware) => getDefaultMiddleware()
      : (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});
